import { connect } from 'react-redux';
import { selectMediaState } from 'redux/modules/device';

const mapMediaState = mediaState => ({
  mediaQueryXs: mediaState.xs,
  mediaQuerySm: mediaState.sm,
  mediaQueryMd: mediaState.md,
  mediaQueryLg: mediaState.lg,
  mediaQueryXl: mediaState.xl,
  mediaQueryXxl: mediaState.xxl,
});

export const wrapDisplayName = (ConnectedComponent, displayName) => {
  ConnectedComponent.displayName = `media(${displayName ||
    ConnectedComponent.displayName.replace(/^Connect\((.*)\)$/, '$1')})`;
  return ConnectedComponent;
};

export const mapStateToProps = state => mapMediaState(selectMediaState(state));

export default (Component, displayName) => wrapDisplayName(connect(mapStateToProps)(Component), displayName);
